import React, { useEffect } from "react";
import { AlertCircle, CheckCircle, X } from "lucide-react";

// ===== RESPONSIVE ALERT COMPONENT =====
const Alert = ({ type, message, onClose, styles, screenSize, fonts }) => {
  // Auto close after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    // Cleanup timer on component unmount
    return () => clearTimeout(timer);
  }, [onClose]);

  // Return alert JSX
  return (
    <div
      style={{
        ...styles.alert,
        backgroundColor:
          type === "error"
            ? "rgba(239, 68, 68, 0.1)"
            : "rgba(34, 197, 94, 0.1)",
        borderColor: type === "error" ? "#ef4444" : "#22c55e",
        color: type === "error" ? "#ef4444" : "#22c55e",
      }}
    >
      {type === "error" ? (
        <AlertCircle size={screenSize === "xs" ? 14 : 16} />
      ) : (
        <CheckCircle size={screenSize === "xs" ? 14 : 16} />
      )}
      <span style={{ fontSize: fonts.body }}>{message}</span>
      <button onClick={onClose} style={styles.alertClose}>
        <X size={screenSize === "xs" ? 12 : 14} />
      </button>
    </div>
  );
};

export default Alert;
